import type { Path } from "@/router";

export function personGrpBenefitsPath(pgaId: string, canOpenPersonGrpTab: boolean): Path {
  return (canOpenPersonGrpTab ? `/people/${pgaId}/benefits/grp` : `/people/${pgaId}`) as Path;
}
